import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import initAmplify from 'config/amplify.config';
import initAxios from 'config/axios.config';
import sentryConfig from 'config/sentry.config';
import initMockServiceWorker from 'config/initMockServiceWorker';
import { Provider } from 'react-redux';
import { store } from 'redux/store';

initAmplify();
initAxios();
sentryConfig();
initMockServiceWorker();

ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>
,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
